import { Link } from "react-router-dom";
import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Sparkles, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-50" data-testid="forgot-page">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <div className="w-8 h-8 rounded-xl bg-[#1E3A8A] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display font-bold text-lg tracking-tight">SuperZeka</span>
        </Link>

        {sent ? (
          <div className="rounded-2xl border border-zinc-200 bg-white p-8" data-testid="forgot-sent">
            <MailCheck className="w-8 h-8 text-[#10B981]" />
            <h1 className="mt-4 font-display text-2xl font-bold text-zinc-900">Bağlantı gönderildi</h1>
            <p className="mt-2 text-sm text-zinc-600 leading-relaxed">
              Eğer bu e-posta kayıtlıysa, şifre sıfırlama bağlantısını e-posta kutuna gönderdik.
              Bağlantı 1 saat içinde geçerli.
            </p>
            <Link to="/giris" className="block mt-6">
              <Button variant="outline" className="w-full rounded-full">Giriş sayfasına dön</Button>
            </Link>
          </div>
        ) : (
          <div className="rounded-2xl border border-zinc-200 bg-white p-8">
            <h1 className="font-display text-2xl font-bold tracking-tight text-zinc-900">Şifremi Unuttum</h1>
            <p className="mt-2 text-sm text-zinc-600">
              E-postanı gir, şifre sıfırlama bağlantısını gönderelim.
            </p>
            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">E-posta</Label>
                <Input
                  id="email"
                  type="email"
                  required
                  data-testid="forgot-email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="rounded-xl"
                  placeholder="ornek@eposta.com"
                />
              </div>
              {err && (
                <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">
                  {err}
                </div>
              )}
              <Button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit"
                className="w-full h-11 rounded-full bg-[#1E3A8A] hover:bg-[#1E40AF] text-white"
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Bağlantı Gönder"}
              </Button>
              <div className="text-center">
                <Link to="/giris" className="text-sm text-zinc-600 hover:text-zinc-900">
                  Giriş sayfasına dön
                </Link>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
